<template>
  <div
    class="main-layout"
    :class="customClass"
  >
    <div
      class="main-layout__container"
      :style="{ 'marginTop': marginTop }"
      :class="containerClass"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import whichbrowser from '@/components/mixins/whichbrowser';

export default {
  name: 'MainLayout',
  mixins: [whichbrowser],
  props: {
    marginTop: {
      type: String,
      default: '0',
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    fixedSize: {
      type: Boolean,
      default: true,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    desktop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAdmin() {
      console.log(this.containerClass);
      return this.$store.state.account.isAdminMode;
    },
    containerClass() {
      const containerClass = [
        this.isIPad ? 'main-layout__container--ipad' : '',
        this.wide ? 'main-layout__container--wide' : '',
        this.small ? 'main-layout__container--small' : '',
        this.desktop ? 'main-layout__container--desktop' : '',
        this.full ? 'main-layout__container--full' : '',
        !this.full && !this.small && !this.wide && !this.desktop
          ? 'main-layout__container--regular'
          : '',
      ];
      return containerClass;
    },
    customClass() {
      const customClass = [
        this.noPadding ? 'main-layout--nopadding' : '',
        this.currentPage,
        this.isAdmin ? 'main-layout--is-admin' : '',
      ];

      return customClass;
    },
    currentPage() {
      return `page-${this.$router.currentRoute.name}`;
    },
  },
};
</script>
<style lang="scss">
$minwidth: 768px;
.main-layout {
  min-height: calc(100vh - 60px);
  background-color: $bg-sales-associate;
  padding-top: 1.3rem;
  padding-bottom: 1px;
  min-width: $minwidth;
  &--nopadding {
    padding-top: 0 !important;
  }

  &--is-admin {
    background-color: $bg-admin !important;
  }

  @media (min-width: 1024px) {
    margin-left: 82px
  }

  // &__fixed-size {
  //   max-width: 1228px;
  // }
  // .centered {
  //   margin-left: auto;
  //   margin-right: auto;
  // }

  &__container {
    margin-left: auto;
    margin-right: auto;
    min-width: $minwidth;
    &--small {
      max-width: 975px;
    }
    &--regular {
      max-width: 1098px;
    }
    &--desktop {
      max-width: 1248px;
    }
    &--ipad {
      padding-left: 20px;
      padding-right: 20px;
    }
    // oirigin
    &--wide {
      padding-left: 14px;
      padding-right: 14px;
      max-width: 1200px;
    }
  }
}
</style>
